import { deleteCookie, getActiveToken } from './cookie';
import { clearAuthData } from './localStore.util';

export function getToken(): string | null {
  if (typeof document === 'undefined') return null;
  const value = getActiveToken();
  if (value == null || value === '' || value === 'null' || value === 'undefined') {
    return null;
  }
  return value;
}

export function clearAuth(): void {
  try {
    deleteCookie('token');
    clearAuthData();
  } catch (err) {
    console.error('clearAuth error:', err);
  }
}
